import React, {Component} from 'react';
import {Button} from 'reactstrap';
import {connect} from 'react-redux';
import autobind from 'autobind-decorator';
import {updateTags} from 'catalog/actions/measures'

@connect(
    null,
    dispatch => ({
        updateTags: (measure, activeTags) => dispatch(updateTags(measure, activeTags))
    })
)
export class MeasureTags extends Component {

    render() {
        const allTags = [
            {
                id: 1,
                name: 'technisch',
                a: 't',
            },
            {
                id: 2,
                name: 'organisatorisch',
                a: 'o'
            },
            {
                id: 3,
                name: 'persönlich',
                a: 'p'
            },
            {
                id: 4,
                name: 'info',
                a: 'i'
            }
        ];
        const {measure} = this.props;
        const activeTags = this.props.measure.tags.map(tag => tag.name)
        console.log(measure, measure.tags)
        console.log(activeTags)
        const isActive = (tag) => {
            return activeTags.includes(tag.name);
        };
        return allTags.map(
            (tag, idx) =>
                <Button
                    className={isActive(tag) ? 'active' : ''}
                    onClick={isActive(tag) ? () => this.deactivate(tag, activeTags) : () => this.activate(tag, activeTags)}
                    key={`measure_tag_${idx}_${measure.id}_${tag.name}`}
                >
                    {tag.a}
                </Button>
        );
    }

    @autobind
    activate(tag, activeTags) {
        console.log(tag)
        this.props.updateTags(this.props.measure, [...activeTags, tag.name])
    }

    @autobind
    deactivate(tag, activeTags) {
        this.props.updateTags(this.props.measure, activeTags.filter(active => active != tag.name))
    }
}
